"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M31.352 4a.667.667 0 0 0-.471 1.139l4.242 4.233-9.323 9.316a.667.667 0 0 0 0 .943l2.568 2.569a.667.667 0 0 0 .943 0l9.322-9.321 4.229 4.221A.667.667 0 0 0 44 16.623V4zM16.648 44a.667.667 0 0 0 .471-1.139l-4.242-4.233 9.323-9.316a.667.667 0 0 0 0-.943L19.632 25.8a.667.667 0 0 0-.943 0l-9.322 9.326L5.138 30.9A.667.667 0 0 0 4 31.377V44z" })
);

